import React from 'react';
import { List, createTheme, ThemeProvider } from '@mui/material';
import Business from '../components/businesses/Business';
import { useLoaderData } from 'react-router-dom';

const theme = createTheme();

const Businesses = () => {
  const businesses = useLoaderData();
  return (
    <ThemeProvider theme={theme}>
      <div className="container">
        <List className="flex-container" component="nav" aria-label="productos seleccionados">
          { businesses.map((business) => {
            return (
              <Business business = {business} />
            );
          })}
        </List>
      </div>
    </ThemeProvider>
  );
}

export default Businesses;
